/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-12 12:08:10
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-04-07 10:23:20
 */
export const queryPage = '/icps/system/sign/intelligent/materials/supplier/queryPage'
export const batchUpdateOrDelete = '/icps/system/sign/intelligent/materials/supplier/updateEnable'
export const saveOrUpdate = '/icps/system/sign/intelligent/materials/supplier/saveOrUpdate'
import request from '@/utils/request'

export function queryTradeStatistics(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/plan/need/queryTradeStatistics',
    method: 'post',
    data
  })
}
